import { combineReducers } from "@reduxjs/toolkit";
import news from "./news/newsUXSlice";
import dividends from "./dividends/dividendsUXSlice";

const uxReportsReducer = combineReducers({
	news,
	dividends,
});

export default uxReportsReducer;
